export default __webpack_public_path__ + "static/media/build_animated.dc1270ca.gif";